import { createAction, handleActions } from "redux-actions";
import { START_SEARCH, FINISH_SEARCH } from "../types";
import scraperConfig from "../scraperConfig";

const defaultState = Object.fromEntries(
    Object.entries(scraperConfig).map(([key]) => [key, { isLoading: false }])
);

export const startArtistSearch = createAction(START_SEARCH, (id) => ({ id }));
const finishArtistSearch = createAction(FINISH_SEARCH, (id) => ({ id }));

export function searchForArtist(artistName) {
    return (dispatch, getState) => {
        dispatch(startArtistSearch());

        const selectedScraper = getState().selectedScraper.value;

        return dispatch(scraperConfig[selectedScraper].fetchArtistDetails(artistName))
            .then((response) => {
                if (response) {
                    return dispatch(
                        scraperConfig[selectedScraper].fetchArtistTracks(response.payload.data)
                    );
                }
                return null;
            })
            .then(() => dispatch(finishArtistSearch()));
    };
}

const artistSearch = handleActions(
    {
        [startArtistSearch]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { isLoading: true }
            };
        },
        [finishArtistSearch]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: { isLoading: false }
            };
        }
    },
    defaultState
);

export default artistSearch;
